import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/irSearchActions';

import PartiesCases from './PartiesCases';

const type = 'parties';
const noDataFoundMessage = 'There are no parties.';
const loggedUser = window.Drupal.settings.currentUser;
export class PartiesCasesContainer extends Component {
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

    getData = () => {
      this.props.dispatch(irActions.getCaseData({
        type,
        case_uuid: this.props.case_uuid,
      }));
    }

  purchaseData = () => {
    this.props.dispatch(irActions.purchaseCaseData({
      type,
      case_uuid: this.props.case_uuid,
    }));
  }

  render() {
    return (
      <PartiesCases
        {...this.props}
        type={type}
        purchaseData={this.purchaseData}
        currentUser={loggedUser}
        noDataFoundMessage={noDataFoundMessage}
      />
    );
  }
}

PartiesCasesContainer.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

PartiesCasesContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  parties: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  return {
    dataReady: irSearch.data_ready,
    parties: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(PartiesCasesContainer);



// WEBPACK FOOTER //
// ./src/components/case/parties/PartiesCasesContainer.js